<template>
  <!-- 咖啡吧首页单品块 -->
  <div>
    <div
      class="meal-item-container"
      :class="{ disabled: disabled }"
      :title="coffee_info.menu_name"
    >
      <span class="title">
        <span v-if="false" class="label">{{ coffee_info.name }}</span>
        <span class="name-box">
          <span class="name">{{ coffee_info.name }}</span>
        </span>
      </span>
      <img class="img" :src="coffee_info.imgUrl" @error="errorLoadImg()" />
      <span class="month-sale">月销量：{{ coffee_info.mSales }}</span>
      <div class="break-line" />
      <div class="price-view">
        <span class="price">
          <span>¥{{ coffee_info.prize }}</span>
          <span v-if="false" class="dis_price"
            >¥{{ coffee_info.actual_price }}</span
          >
        </span>
        <span class="count-view">
          <img
            v-if="disabled"
            class="add"
            src="../../../../static/img/meals/icon_tj_pre.png"
          />
          <div class="" v-if="coffee_info.status === 2">售罄</div>
          <img
            v-if="coffee_info.status === 1"
            @click.stop="handleAddShop(coffee_info)"
            class="add"
            src="../../../../static/img/meals/icon_tj.png"
          />
        </span>
      </div>
    </div>
    <AddShopModal
      :addVisible="addVisible"
      :detailData="detailData"
      @closeClick="changeVisible"
    />
  </div>
</template>

<script>
import DEFAULT_IMG from "../../../../static/img/meals/pic_home_default.png";
import AddShopModal from "../AddShopModal.vue";

export default {
  name: "MealItem",
  props: {
    coffee_info: {
      type: Object,
      default: {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddShopModal,
  },
  data() {
    return {
      addVisible: false, // 控制添加模态框弹出
      detailData: {}, // 加入购物车模态框详情数据
    };
  },
  computed: {  },
  methods: {
     /**
     *  控制模态框打开
     */
    handleAddShop(item) {
      this.addVisible = true;
      this.detailData = item;
    },
    changeVisible(val) {
      this.addVisible = val;
    },
    /**
     * 检查是否能够下单，不能下单给出提示
     */
    checkDisabled() {
      if (this.disabled) {
        this.$store.commit("show_alert", "暂未开启下单");
      }
      return this.disabled;
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg() {
      //   const eventTag = event.toElement || event.target;
      //   eventTag.src = "../../../../img/meals/pic_home_default.png";
    },
  },
};
</script>

<style lang="less" scoped>
.meal-item-container {
  width: 220px;
  height: 310px; // 300px
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  &.disabled {
    cursor: not-allowed;
    .price-view .add {
      cursor: not-allowed;
    }
  }
  .title {
    height: 50px; // 40px
    width: 200px; // 180px
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 15px;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    .label {
      margin-top: 3px;
      width: 36px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
      font-size: 14px;
      color: #ff7814;
      background-image: url("../../../../static/img/meals/biaoqian.png");
    }
    .name-box {
      max-width: 158px;
      .name {
        display: inline-block;
        display: flex;
        justify-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .remark {
        position: relative;
        top: -5px;
        display: inline-block;
        max-width: 158px;
        font-size: 12px;
        color: #a5a5a5;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .img {
    width: 140px;
    height: 140px;
    border-radius: 70px;
    margin-top: 18px;
  }
  .month-sale {
    margin-top: 2px;
    font-size: 16px;
    color: #ff7814;
  }
  .star {
    width: 16px;
    height: 16px;
    margin: 5px;
  }
  .break-line {
    width: 184px;
    margin-top: 10px;
    margin-bottom: 5px;
    border-bottom: 1px solid #e0e0e0;
  }
  .price-view {
    width: 184px;
    height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .price {
      font-size: 20px;
      color: #333333;
      .dis_price {
        text-decoration: line-through;
        font-size: 16px;
        color: #999999;
      }
    }
    .count-view {
      height: 24px;
      display: flex;
      justify-content: center;
      text-align: center;
    }
    .count {
      width: 30px;
      display: inline-block;
      font-size: 18px;
      color: #333333;
    }
    .minus,
    .add {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}
.meal-item-container:hover {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/components/CoffeeItem.vue